module.exports = __webpack_public_path__ + "img/th.5f46852b.svg";